import { EntityManagerConfig } from '../models/entity-config';

export class GestioneEMC extends EntityManagerConfig {
  override initFields(): void {
    this.cmdFields = [];
  }
}
